import React from 'react'

export default function P(props) {
    return (
        <p {...props}>
            {props.data}
        </p>
    )
}
